import { failureTypeValues, type FailureType } from "../api";

// Keyed by the generated FailureType, so a failure type added or removed on the
// backend fails the build until it is described here.
const FAILURE_TYPE_DESCRIPTIONS: Record<FailureType, string> = {
    Hallucination: "Provides information that is made up or not supported by any source.",
    "Incorrect answer": "Provides an answer that is not fabricated but does not correctly address the question or contains wrong information.",
    "Incomplete answer": "Provides a partially correct answer, but important details are missing.",
    "No answer": "Does not provide an answer.",
    "Question issue": "The question is unclear, too broad, or ambiguous and cannot be answered reliably.",
    "Technical issue": "The failure is caused by a system or technical problem (e.g., UI issues, unsupported functionality).",
    "Policy issue": "Response is blocked due to incorrect policy constraints (e.g. PHI detection).",
    "Source issue": "Sources are missing, incorrect, unavailable, or not properly pulled to support the answer.",
    Other: "Issues that do not fit any of the categories above."
};

export const FAILURE_TYPES: readonly FailureType[] = failureTypeValues;

export const FAILURE_TYPE_DEFINITIONS = FAILURE_TYPES.map(label => ({ label, description: FAILURE_TYPE_DESCRIPTIONS[label] }));

export const isFailureType = (value: string): value is FailureType => (FAILURE_TYPES as readonly string[]).includes(value);
